import { colors } from "@material-ui/core";

import { Button } from "@/design-system/components/Button/Button";
import { toast } from "@/design-system/components/Toast/Toast";

import { MicrosoftIcon } from "@/components/icons/themes/logos";
import { DestinationConfigRow } from "@/destinations/configs/shared/ConfigPageRow";
import { makeRequest } from "@/util";

export function OAuthModal() {
  return null;
}

export function OAuthRow({ existingConfig, destination }) {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const disableRow = !existingConfig.id;

  const onOpenConfigModal = () => {
    makeRequest("get_oauth_url", {
      integration_name: destination.slug,
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup " + destination.name + ".",
        );
      });
  };

  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#0078D4]"
      leadingIcon={<MicrosoftIcon className="h-4 w-4" />}
      onClick={onOpenConfigModal}
    >
      {oauthConfigured ? "Reconnect" : "Connect with Microsoft"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      disabled={disableRow}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
}
